import { SortDescriptor } from "react-aria-components";

import { STACK_WEBHOOKS_COLUMN_ID } from "./constants";
import { WebhookIntegrationWithTimestamp } from "./types";

const compareWebhooks = (
  a: WebhookIntegrationWithTimestamp,
  b: WebhookIntegrationWithTimestamp,
  column: SortDescriptor["column"]
) => {
  switch (column) {
    case STACK_WEBHOOKS_COLUMN_ID.ENDPOINT:
      return a.endpoint.localeCompare(b.endpoint);
    case STACK_WEBHOOKS_COLUMN_ID.STATUS:
      return Number(a.enabled) - Number(b.enabled);
    case STACK_WEBHOOKS_COLUMN_ID.CREATED_AT:
      return a.createdAt - b.createdAt;
    default:
      return 0;
  }
};

export const sortStackWebhooks = (
  webhooks: WebhookIntegrationWithTimestamp[],
  sortDescriptor: SortDescriptor
) => {
  if (!sortDescriptor.column) {
    return webhooks;
  }

  const direction = sortDescriptor.direction === "ascending" ? 1 : -1;

  return [...webhooks].sort((a, b) => compareWebhooks(a, b, sortDescriptor.column) * direction);
};
